import placeholder from "@src/assets/images/image-placeholder.png";
import themeConfig from "@src/configs/theme-config";
import { useMemo } from "react";

/**
 * @param {{
 *   className?: string,
 *   src: string,
 *   id?: string,
 *   width?: number | null,
 *   height?: number | null,
 *   alt?: string,
 *   onClick?: () => void,
 *   testId?: string,
 *   svgWidth?: number | null
 * }} props
 */
const ImageWrapper = ({
    className = "",
    src,
    id = "",
    width = null,
    height = null,
    alt = "",
    onClick = () => {},
    testId = "",
    ...rest
}) => {

    const imageStyle = useMemo(() => {
        if (!width && !height) return undefined;
        return { ...(width ? { width } : {}), ...(height ? { height } : {}) };
    }, [width, height]);
    return (
        <img
            src={`${themeConfig.bucketImgCdnURL}/${src}`}
            loading="lazy"
            className={className}
            id={id}
            {...rest}
            data-cy={testId || id}
            style={imageStyle}
            onClick={onClick}
            alt={alt}
            onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = placeholder;
            }}/>
    );
};

export default ImageWrapper;
